// Условия экрана «Копии» в адресе страницы (002: contracts/ui.md, «/ops/backups»; FR-048):
// итог («только неудачные» — result=failed) и период. Период — даты в поясе установки; в запрос
// уходят моменты начала и конца дня, как в журнале действий.
import type { BackupsQuery } from '@kp/contracts';
import { dayEnd, dayStart } from '../../app/format.ts';

export interface BackupsSearch {
  result?: 'ok' | 'failed';
  /** Первый день периода: 2026-10-14. */
  from?: string;
  /** Последний день периода включительно. */
  to?: string;
}

const DATE = /^\d{4}-\d{2}-\d{2}$/;

/** Для адреса страницы: validateSearch маршрута /ops/backups. */
export function parseBackupsSearch(search: Record<string, unknown>): BackupsSearch {
  const result: BackupsSearch = {};
  if (search.result === 'ok' || search.result === 'failed') result.result = search.result;
  if (typeof search.from === 'string' && DATE.test(search.from)) result.from = search.from;
  if (typeof search.to === 'string' && DATE.test(search.to)) result.to = search.to;
  return result;
}

/** Условия сужают список: «Ничего не найдено» вместо «Копий ещё нет». */
export function hasBackupsFilters(search: BackupsSearch): boolean {
  return Boolean(search.result || search.from || search.to);
}

/** Условия запроса к серверу. */
export function backupsFilters(search: BackupsSearch, timeZone: string): BackupsQuery {
  return {
    result: search.result,
    from: search.from ? dayStart(search.from, timeZone) : undefined,
    to: search.to ? dayEnd(search.to, timeZone) : undefined,
  };
}
